<template lang="pug">
  #main
    .main-nav
      .main-nav__container
        Nav.nav_padding_8

    .main
      MainContent
      .main-content__border

      HowBlock
      .main-content__border

      //VideoContent

      PartnerBlock
      .main-content__border

      MoneyBlock

      RegisterBlock
</template>

<script>
// @ is an alias to /src
import Nav from '../layouts/parts/Nav'
import MainContent from '../components/widgets/MainContent'
import HowBlock from '../components/widgets/HowBlock'
import VideoContent from '../components/widgets/VideoContent'
import PartnerBlock from '../components/widgets/PartnerBlock'
import MoneyBlock from '../components/widgets/MoneyBlock'
import RegisterBlock from '../components/widgets/RegisterBlock'

export default {
  name: 'home',
  components: {
    Nav,
    MainContent,
    HowBlock,
    VideoContent,
    PartnerBlock,
    MoneyBlock,
    RegisterBlock
  }
}
</script>

<style lang="scss">
  .main {
    min-height: 600px;
    position: relative;
    z-index: 1;
    background-color: #fff;
  }
</style>
